import { useState } from 'react'
import {
  loginPlatformLegacy,
  LoginCredentials,
  useWistorAuth,
} from '../../api/auth'
import { SubmitHandler, useForm } from 'react-hook-form'
import { LoginButtonBar, LoginPageLayout } from './LoginPageLayout'
import { useHistory } from 'react-router-dom'
import { Icon } from '../widgets/Icon'
import { useFeatureFlags } from '../../flags'
import { SingleLoginButton, SingleLogoutButton } from '../SingleLogin'

const EMAIL_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i

export function Login() {
  const flags = useFeatureFlags()
  const auth = useWistorAuth()

  if (auth.status === 'authenticating') {

  }

  return (
    <LoginPageLayout>
      <h1>Welcome to Wistor</h1>

      {auth.status === 'unauthorized' && (
        <div className="mt-4 py-3 px-4 rounded-md bg-red-200 text-red-950">
          <div className="flex gap-4 items-center">
            <Icon icon="triangle-exclamation" />
            <div className="flex flex-col">
              <div className="font-medium w-full">{auth.errorMessage}</div>
            </div>
          </div>
        {auth.status === 'unauthorized' && auth.visibleSingleLogout && (
          <SingleLogoutButton />
        )}
        </div>
      )}

      {flags.singleLogin && (<>
        {((auth.status !== 'unauthorized') || (auth.status === 'unauthorized' && auth.visibleSingleLogin)) && ( 
          <SingleLoginButton />
         )}
        <hr className="h-0 border-t border-l-indigo-900 mt-4" />
      </>)}

      <LegacyLoginForm />

    </LoginPageLayout>
  )
}

function LegacyLoginForm() {
  const {
    register,
    handleSubmit,
    formState,
  } = useForm<LoginCredentials>()
  const history = useHistory()
  const [ errorReason, setErrorReason ] = useState<string | null>(null)

  const doLogin: SubmitHandler<LoginCredentials> = async loginCredentials => {
    setErrorReason(null)
    const resp = await loginPlatformLegacy(loginCredentials)

    if (!resp.success) return setErrorReason(resp.reason)

    if (window.location.pathname === '/login') {
      history.push('/')
    }
    window.location.reload()
  }

  return (
    <form onSubmit={handleSubmit(doLogin)}>
      <label>
        Username

        <input type="email" required
               className="font-normal"
               {...register('email', { required: true, pattern: EMAIL_PATTERN })} />
      </label>
      <label>
        Password

        <input type="password" required
               className="font-normal"
               {...register('password', { required: true })} />
      </label>

      <LoginButtonBar disabled={formState.isSubmitting}
                      isLoggingIn={formState.isSubmitting}
                      error={errorReason} />
    </form>
  )
}
